import { showTransparentPopupAction } from 'js/components/common/popups/TransparentPopup';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const showGeoComplyPopupAction = ({ useTransparentPopup, ...action }) => {
    if (useTransparentPopup) {
        return showTransparentPopupAction(action);
    }

    return showCommonPopupAction(action);
};
